import React, { Component } from 'react';
import { observer } from 'mobx-react';
import BannerListFilters from './BannerListFilters';
import BannerListService from '../services/BannerListService';

class BannerListFilterContainer extends Component {
  render() {
    return (
      <BannerListFilters
        onChange={BannerListService.form.setValue}
        onSearch={BannerListService.load}
        values={BannerListService.form.getValues()}
      />
    );
  }
}

export default observer(BannerListFilterContainer);
